import moment from "moment";
import { dateFormat, deepCopy, getList, getSeriesById } from "../../app/util";

export const getPropertyDetails = (active_tile, active_api, summaryDataView) => {
    let result = getSeriesById("OSR").data;
    switch (active_tile[0]) {
        case 'hotel_summary':
            active_api = "HotelSummaryRange";
            result = getSeriesById(active_api).data;
            break;
        case 'market_summary':
            active_api = "MarketSummaryRange";
            result = getSeriesById(active_api).data;
            break;
        case 'market':
            result = getSeriesById("MarketARISegmented").data;
            break;
        default:
            result = getSeriesById("OSR").data;
            break;
    }
    return result;
}

export const primaryHeaderDisplay = ({ display, type, dataId }, app_state, ui_state, data_setup = [], tile) => {
    const { workspace_controls, comp_as_of_date, comp_stay_range, data_as_of, metas } = app_state;
    const as_of_date = app_state.primary_stay_range.as_of_date;
    const { sdlyOn, pickUpType, isRoomTypePricing, isRestrictionsRoomType, dayDate, scopeType } = workspace_controls;
    const { active_tiles } = ui_state;
    let dtFormat = "ddd, MMM DD, YYYY";
    let pickupDays = app_state.workspace_controls.pickUpDays;
    let sdlyPickupDays = 364 + parseInt(pickupDays);
    // let propDetails = (['hotel_summary', 'market_summary'].some(elem => active_tiles.includes(elem))) ? getSeriesById("HotelSummary").data : getSeriesById("OSR").data;
    let propDetails = getPropertyDetails(active_tiles, app_state.active_apis[0], app_state.summaryDataView);
    let propDetailsMarket = getSeriesById("MarketARISegmented").data;
    let startDate = app_state.primary_stay_range.date_from;
    let endDate = app_state.primary_stay_range.date_until;
    let yearArr = getList(startDate, endDate);
    let compYearArr = getList(app_state.comp_stay_range.date_from, app_state.comp_stay_range.date_until)
    let sdYear = workspace_controls.sdYear;
    let asOfDate = as_of_date;
    let asOfDateSummary = app_state.summary_stay_range.as_of_date;
    let budgetAsOfDate = moment(metas.budget.as_of_date).format(dtFormat);
    let sdlyDateMeta;//= dateFormat(moment(as_of_date).subtract(364, "days"), "ddd, MMM DD, YYYY");
    if (propDetails) {
        // if (!propDetails['meta'].hasOwnProperty("as_of" && !propDetails['meta'].hasOwnProperty("asof")) ){ propDetails['meta']['as_of'] = data_as_of; }
        if (!propDetails['meta'].hasOwnProperty("as_of") && propDetails['meta'].hasOwnProperty("asof")) { propDetails['meta']['as_of'] = propDetails['meta']['asof']; }
        asOfDate = (propDetails && propDetails['meta'] && moment(propDetails['meta']['as_of']).isSame(as_of_date)) ? dateFormat(as_of_date, "ddd, MMM DD, YYYY") : dateFormat(propDetails['meta']['as_of'], "ddd, MMM DD, YYYY");
        sdlyDateMeta = (dayDate === 'day') ? propDetails['meta']['sdly_asof'] : propDetails['meta']['sdtly_asof'];
        asOfDateSummary = asOfDate;
    }
    // debugger;
    let sdlyText = (dayDate === 'day') ? "SDLY" : "SDTLY";
    let otbSdlyDate = (propDetails) ? sdlyDateMeta : dateFormat(moment(as_of_date).subtract(364, "days"), "ddd, MMM DD, YYYY");
    let finalValue = display;
    if (active_tiles[0] === 'pricing' && isRoomTypePricing && type === "roomTypeColumn") {
        finalValue = (<><p className="room-code">{display.room_code} {(display.is_base && "(Base) ")}
            {"[" + display.room_inventory + "] "} </p>
            <p className="room-display-name">{display.room_display_name}</p></>);
    } else if (active_tiles[0] === 'restrictions' && isRestrictionsRoomType && type === "roomTypeColumn") {
        finalValue = (<><p className="room-code">{display.room_code} {(display.is_base && "(Base) ")}
            {"[" + display.room_inventory + "] "} </p>
            <p className="room-display-name">{display.room_display_name}</p></>);
    } else {
        // console.log("display =>  ", display);
        display = replaceAll(display, "%dayscount%", app_state.workspace_controls.pickUpDays)
        display = replaceAll(display, "%asOfDate%", asOfDate)
        display = replaceAll(display, "{sdYear}", sdYear)
        display = replaceAll(display, "{budget_asof_date}", budgetAsOfDate)
        display = replaceAll(display, "{day-date}", dayDate)
        display = replaceAll(display, "{sdlyText}", sdlyText)
        display = replaceAll(display, "{sdYear-actuals}", getSdyearsActuals(propDetails, dayDate, startDate, endDate, sdYear));
        display = replaceAll(display, "{sdYear-market-actuals}", getSdyearsActuals(propDetailsMarket, dayDate));
        var result = display.split(/[{}]/);
        if (result.length > 1) {
            let dayDisplay = result[0].split(/[%%]/);
            if (result[1] === "asofdatetime") {
                finalValue = result[0] + " " + new moment(as_of_date).format("ddd, MMM DD") + " " + moment().format("HH:MM A") + " (GMT" + moment().format("Z") + ")";
                //Added this for compset enhancement
                if (tile === 'compset' || (["Compset"].includes(dataId))) {
                    let compsetData = scopeType === 'Dba' ? getSeriesById("CompsetBookingPace").data : getSeriesById("Compset").data;
                    if (scopeType === 'Date') {
                        finalValue = result[0] + " " + new moment(compsetData?.update_time_current).format("ddd, MMM DD") + " " + moment().format("HH:MM A") + " (GMT" + moment().format("Z") + ")";
                    }
                    if (scopeType === 'Dba') {
                        finalValue = result[0] + " " + new moment(compsetData?.update_time_current).format("ddd, MMM DD") + " " + moment().format("HH:MM A") + " (GMT" + moment().format("Z") + ")";
                    }
                }

            } else if (result[1] === "compAsOfDate") {
                finalValue = result[0] + " " + new moment(comp_stay_range.comp_as_of_date).format(dtFormat);
            } else if (result[1] === "dbamaindate") {
                finalValue = result[0] + " " + new moment(startDate).format(dtFormat);
            } else if (result[1] === "dbacomparisiondate") {
                finalValue = result[0] + " " + new moment(app_state.comp_stay_range.date_from).format(dtFormat);
            } else if (result[1] === "comparisonrangeyear") {
                finalValue = (compYearArr.length) ? compYearArr.join(" - ") : moment().format("YYYY");
                finalValue = "Comparison Pace - " + finalValue;
            } else if (result[1] === "rangeyear" && ['flights'].includes(active_tiles[0])) {
                let flightsYearArr = [];
                if (data_setup && data_setup.length) {
                    let monthsData = data_setup.map(monthData =>
                        monthData.find(item => item.id === "staydates").month
                    );
                    flightsYearArr = [...new Set(monthsData.map(date => moment(date, "MMM, YYYY").year()))];
                }
                finalValue = (flightsYearArr.length) ? flightsYearArr.join(" - ") : moment().format("YYYY");
            } else if (result[1] === "rangeyear" && !['market_summary', 'hotel_summary'].includes(active_tiles[0])) {
                finalValue = (yearArr.length) ? yearArr.join(" - ") : moment().format("YYYY");
            } else if (result[1] === "rangeyear" && ['market_summary', 'hotel_summary'].includes(active_tiles[0])) {
                let startDate_summary = app_state.summary_stay_range.date_from;
                let endDate_summary = app_state.summary_stay_range.date_until;
                let yearArr_summary = getList(startDate_summary, endDate_summary);
                finalValue = (yearArr_summary.length) ? yearArr_summary.join(" - ") : moment().format("YYYY");
            } else if (result[1] === "asOfDateSummary") {
                let asOfDate_Summary = dateFormat(asOfDateSummary, "ddd, MMM DD, YYYY")
                finalValue = result[0] + " " + asOfDate_Summary;
            } else if (result[1] === "asOfDate") {
                asOfDate = dateFormat(asOfDate, "ddd, MMM DD, YYYY")
                finalValue = result[0] + " " + asOfDate;
            } else if (result[1] === "otbSdlyDate" && propDetails) {
                let sdlyDateMeta = (dayDate === 'day') ? propDetails['meta']['sdly_asof'] : propDetails['meta']['sdtly_asof'];
                let otbSdlyDate = (propDetails) ? sdlyDateMeta : dateFormat(moment(as_of_date).subtract(364, "days"), "ddd, MMM DD, YYYY");
                finalValue = result[0] + " " + dateFormat(otbSdlyDate, "ddd, MMM DD, YYYY");
            } else if (result[1] === "subsYearDays") {
                finalValue = result[0] + " " + dateFormat(moment(otbSdlyDate), "ddd, MMM DD, YYYY");
            } else if (result[1] === "substract364") {
                //let updatedDate = app_state.metas.osr.sdly_asof;
                let sdlyDateMeta = (dayDate === 'day') ? propDetails['meta']['sdly_asof'] : propDetails['meta']['sdtly_asof'];
                let updatedDate = (propDetails) ? sdlyDateMeta : dateFormat(moment(as_of_date).subtract(364, "days"), "ddd, MMM DD, YYYY");
                if (getSeriesById(app_state.active_apis[0]).data) {
                    console.log("substract364", getSeriesById(app_state.active_apis[0]).data)
                }
                finalValue = result[0] + " " + dateFormat(moment(updatedDate), "ddd, MMM DD, YYYY");
            } else if (result[1] === "subsPickupDays") {
                finalValue = result[0] + " " + dateFormat(moment(asOfDate).subtract(pickupDays, "days"), "ddd, MMM DD, YYYY");
            } else if (result[1] === "sdlyPickupDays") {
                finalValue = result[0] + " " + dateFormat(moment(otbSdlyDate).subtract(pickupDays, "days"), "ddd, MMM DD, YYYY");
            } else if (result[1] === "UNCONSTRAINED") {
                finalValue = (workspace_controls.unconstrained) ? "Unconstrained " + result[2] : "" + result[2];// dateFormat(moment(as_of_date).subtract(sdlyPickupDays, "days"), "ddd, MMM DD, YYYY");
            }
            else if (result[1] === "primaryRange") {
                let resultString = '';
                if (moment(app_state.primary_stay_range.date_from).isSame(app_state.primary_stay_range.date_until, 'year')) {
                    resultString = `${dateFormat(moment(app_state.primary_stay_range.date_from), "ddd, MMM DD")} - ${dateFormat(moment(app_state.primary_stay_range.date_until), "ddd, MMM DD, YYYY")}`;
                } else {
                    resultString = `${dateFormat(moment(app_state.primary_stay_range.date_from), "ddd, MMM DD, YYYY")} - ${dateFormat(moment(app_state.primary_stay_range.date_until), "ddd, MMM DD, YYYY")}`;
                }
                finalValue = `${result[0]} ${resultString}`;
            }
            else if (result[1] === "SDLYRange") {
                // let propDetailObj = propDetails['meta'];
                // const resultString = `${dateFormat(moment(propDetailObj.sdly_from), "ddd, MMM DD")} - ${dateFormat(moment(propDetailObj.sdly_to), "ddd, MMM DD, YYYY")}`;
                const resultString = getSdyearsActuals(propDetails, dayDate, startDate, endDate, sdYear);
                finalValue = `${result[0]} ${resultString}`;
            }
            else if (result[1] === "summaryRange") {
                let resultString = '';
                if (moment(app_state.summary_stay_range.date_from).isSame(app_state.summary_stay_range.date_until, 'year')) {
                    resultString = `${dateFormat(moment(app_state.summary_stay_range.date_from), "ddd, MMM DD")} - ${dateFormat(moment(app_state.summary_stay_range.date_until), "ddd, MMM DD, YYYY")}`;
                } else {
                    resultString = `${dateFormat(moment(app_state.summary_stay_range.date_from), "ddd, MMM DD, YYYY")} - ${dateFormat(moment(app_state.summary_stay_range.date_until), "ddd, MMM DD, YYYY")}`;
                }
                finalValue = `${result[0]} ${resultString}`;
            }

        } else {
            finalValue = result[0];
        }



        if (active_tiles[0] === 'pricing') {
            finalValue = (<p>{finalValue}</p>);
        } else {
            finalValue = (<span className="no-wrap">{finalValue}</span>);
        }
    }

    return finalValue;
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
    if (str) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    } else {
        return "";
    }
}

function getSdyearsActuals(propDetails, dayDate, startDate, endDate, sdYear) {
    let sdlyTo = (dayDate === 'day') ? "sdly_to" : "sdtly_to";
    let sdlyFrom = (dayDate === 'day') ? "sdly_from" : "sdtly_from";

    let startYear = 0;
    let endYear = 0;
    if (dayDate === "date") {
        startYear = moment(startDate).year() - sdYear;
        endYear = moment(endDate).year() - sdYear;
    }

    let result = '';
    if (propDetails && propDetails["meta"][sdlyFrom] && propDetails["meta"][sdlyTo]) {

        let fromYear = (dayDate === 'day') ? propDetails["meta"][sdlyFrom] : propDetails["meta"]['sdtly_from'];
        let toYear = (dayDate === 'day') ? propDetails["meta"][sdlyTo] : propDetails["meta"]['sdtly_to'];

        if (moment(propDetails["meta"][sdlyFrom]).isSame(propDetails["meta"][sdlyTo], 'year')) {
            result = moment(fromYear).format('ddd, MMM DD') + " - " + moment(toYear).format('ddd, MMM DD, YYYY');
        } else {
            result = moment(fromYear).format('ddd, MMM DD, YYYY') + " - " + moment(toYear).format('ddd, MMM DD, YYYY');
        }
    }
    return result;
}

export const hasColumnSettingsChanged = (sysDefaultColumns = [], savedColumns = []) => {
    let isChanged = false;
    sysDefaultColumns.forEach((col) => {
        if (!isChanged) {
            let savedCol = savedColumns.find(item => item.id === col.id);
            isChanged = savedCol ? savedCol.order !== col.order : false;
            if (savedCol) {
                savedCol.subcolumns.forEach((sub) => {
                    if (!isChanged) {
                        let savedSub = col.subcolumns.find(s => s.value === sub.value);
                        isChanged = savedSub ? (savedSub.hidden !== sub.hidden || savedSub.order !== sub.order) : false;
                    }
                });
            }
        }
    });
    return isChanged;
}
